<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <!-- Header -->
        <!-- <div class="d-md-flex align-items-center"> -->
        <vs-row class="d-md-flex justify-content-between">
          <vs-col vs-lg="3" vs-sm="12" vs-xs="12">
            <h3 class="card-title">Historia zmian salda</h3>
            <h5 class="card-subtitle text-muted font-weight-normal">Cały okres uczestnictwa</h5>
          </vs-col>
          <vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="filters">
            <vs-row class="d-md-flex justify-content-end">
              <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
                <vs-select class="w-100" label="Kwota" v-model="kwota">
                  <vs-select-item :key="index" :value="item.value" :text="item.text"
                    v-for="(item,index) in kwotaoptions" />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
                <vs-select class="w-100" label="Typ transkacji" v-model="type">
                  <vs-select-item :key="index" :value="item.value" :text="item.text"
                    v-for="(item,index) in typeoptions" />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                <label for="picker" class="vs-select--label">Data</label> <br>
                <date-range-picker ref="picker" id="picker" v-model="dateRange" :locale-data="localeData"
                  :ranges="false" :auto-apply="true">
                </date-range-picker>
                <!-- <vs-input type="date" v-model="date1" class="w-100" label="Data od" /> -->
              </vs-col>
              <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
                <vs-row >
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="6" class="pr-1 sm-desktop-no-padding">
                    <vs-button color="success" type="filled" class="mt-4 w-100" @click="getFilteredHistory">Filtruj
                    </vs-button>
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="6" class="pl-1 sm-desktop-no-padding">
                    <vs-button color="danger" type="filled" class="mt-4 w-100" @click="reset">Resetuj</vs-button>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>

        </vs-row>
        <!-- </div> -->
        <PointTable :history="history"></PointTable>
      </vs-card>
    </vs-col>
   
    <Footer></Footer>
  
  </vs-row>
</template>

<script>
  import PointTable from "../dashboards/dashboard-components/month-table/PointTable";
  import historyDataMixin from "../../mixins/historyDataMixin.js";
  import DateRangePicker from 'vue2-daterange-picker';
  import Footer from "../extra-components/Footer";
  //you need to import the CSS manually (in case you want to override it)
  import '../../assets/css/vue2-daterange-picker.css'
  // //////////////////////////////////////////
  // Export Here
  // //////////////////////////////////////////
  export default {
    name: "PanelKlubowicza",
    mixins: [
      historyDataMixin
    ],
    data: () => ({
      title: "History",
      // Month Table
      date1: "",
      date2: "",
      type: "",
      typeoptions: [{
          text: "Wybierz...",
          value: ""
        },
        {
          text: "Dodanie punktów",
          value: "add"
        },
        {
          text: "Odjęcie punktów",
          value: "sub"
        },
      ],
      kwota: "",
      kwotaoptions: [{
          text: "Wybierz...",
          value: ""
        },
        {
          text: "do 50",
          value: 50
        },
        {
          text: "do 100",
          value: 100
        },
        {
          text: "do 500",
          value: 500
        },
        {
          text: "powyżej",
          value: "more"
        }
      ],
      history: [],
      dateRange: {
        startDate: null,
        endDate: null
      },
      localeData: {
        format: 'dd.mm.yyyy',
        separator: ' - ',
        applyLabel: 'Zaakceptuj',
        cancelLabel: 'Anuluj',
        weekLabel: 'T',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień',
          'Październik', 'Listopad', 'Grudzień'
        ],
        firstDay: 1
      },

    }),
    components: {
      PointTable,
      DateRangePicker,
      Footer
    },
    created() {
      this.getHistory();
    },
    updated() {

    },
    methods: {
      reset() {
        this.date1 = "";
        this.date2 = "";
        this.dateRange.startDate = null;
        this.dateRange.endDate = null;
        this.type = "";
        this.kwota = "";
        this.getHistory();
      },
      getFilteredHistory() {
        // eslint-disable-next-line
        console.log('Get filtered history')
        let options = {
          type: this.type,
          created_at: this.dateRange.startDate && this.dateRange.endDate ? (this.formatDateToString(this.dateRange.startDate) + "--" + this.formatDateToString(this.dateRange.endDate)) : '',
          price: this.kwota,
        }
        this.getHistory(options);
      },
      formatDateToString(date) {
        // 01, 02, 03, ... 29, 30, 31
        var dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
        // 01, 02, 03, ... 10, 11, 12
        var MM = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
        // 1970, 1971, ... 2015, 2016, ...
        var yyyy = date.getFullYear();

        // create the format you want
        return (yyyy + "-" + MM + "-" + dd);
      }
    }
  };

</script>

<style>
@media screen and (max-width: 1200px) and (min-width: 901px) {
  .filters {
    width: 65% !important;
  }
}
@media screen and (max-width: 1300px) and (min-width: 901px) {
  .sm-desktop-no-padding{
    padding: 0 .25rem 0 .1rem !important;
  }
}
</style>